import { SplunkRum } from '@splunk/otel-web';
import { getEnvironmentFromHost } from '@ace-clublabs/log-cannon';
import { splunkRUM } from './utils/constants';

SplunkRum.init({
  realm: splunkRUM.SPLUNK_REALM,
  rumAccessToken: splunkRUM.SPLUNK_RUM_AUTH,
  applicationName: splunkRUM.SPLUNK_APP_NAME,
  deploymentEnvironment: getEnvironmentFromHost(),
});
